import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExitFullScreen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 2V4.8C8 5.92011 8 6.48016 7.78201 6.90798C7.59027 7.28431 7.28431 7.59027 6.90798 7.78201C6.48016 8 5.9201 8 4.8 8H2M8 22V19.2C8 18.0799 8 17.5198 7.78201 17.092C7.59027 16.7157 7.28431 16.4097 6.90798 16.218C6.48016 16 5.9201 16 4.8 16H2M16 2V4.8C16 5.92011 16 6.48016 16.218 6.90798C16.4097 7.28431 16.7157 7.59027 17.092 7.78201C17.5198 8 18.0799 8 19.2 8H22M16 22V19.2C16 18.0799 16 17.5198 16.218 17.092C16.4097 16.7157 16.7157 16.4097 17.092 16.218C17.5198 16 18.0799 16 19.2 16H22",
		stroke: "#EFEEF0",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgExitFullScreen;
